(function () {
    'use strict';

    run.admin.parts.tileOpenFile = function() {
        function open(path) {
            let command = '';
            switch (process.platform) {
                case 'darwin':
                    command = 'open';
                    break;
                case 'win32':
                    command = 'start';
                    break;
                default:
                    command = 'xdg-open';
                    break;
            }
            return child_process.execSync(`${command} "${path}"`);
        }

        const toolLinks = document.querySelectorAll('a.tool__visit');
        if (toolLinks.length > 0) {
            for (let i = 0; i < toolLinks.length; i++) {
                toolLinks[i].addEventListener('click', (e) => {
                    const url = e.target.href;
                    if (url.startsWith('file://')) {
                        open(url);
                    }
                });
            }
        }
    };
})();
